import { render, staticRenderFns } from "./DoughnutData.vue?vue&type=template&id=0ade64b7&scoped=true"
import script from "./DoughnutData.vue?vue&type=script&lang=js"
export * from "./DoughnutData.vue?vue&type=script&lang=js"
import style0 from "./DoughnutData.vue?vue&type=style&index=0&id=0ade64b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ade64b7",
  null
  
)

export default component.exports